import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../store";

interface Sheet {
  properties: {
    sheetId: number;
    title: string;
    index: number;
  };
}

interface Spreadsheet {
  spreadsheetId: string;
  spreadsheetUrl: string;
  sheets: Sheet[];
}

export const initialState: Spreadsheet = {
  spreadsheetId: "",
  spreadsheetUrl: "",
  sheets: [],
};

const spreadsheetSlice = createSlice({
  name: "spreadsheet",
  initialState,
  reducers: {
    setSpreadsheet(_state, action: PayloadAction<Spreadsheet>) {
      return action.payload;
    },
    logoutSpreadsheet() {
      return initialState;
    },
  },
});

export const selectSpreadsheet = (state: RootState) => state.spreadsheet;

export const { setSpreadsheet, logoutSpreadsheet } = spreadsheetSlice.actions;
export default spreadsheetSlice.reducer;
